import type { ServerResponseV1 } from "@/http"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

export interface ICommentPostRequest {
  contentId: number
  contentType: number
  content: string
  parentId?: number
}

interface UsePostCommentArgs {
  eventVaultId: number
  commentRequest: ICommentPostRequest
}

export async function postComment(eventVaultId: number, commentRequest: ICommentPostRequest) {
  await v1.post<ServerResponseV1<void>>(`/${eventVaultId}/comments`, commentRequest)
}

export function usePostComment() {
  return useMutation({
    mutationFn: ({ eventVaultId, commentRequest }: UsePostCommentArgs) => postComment(eventVaultId, commentRequest),
  })
}
